import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { FormKitFrameworkContext, createMessage } from '@formkit/core'
import { onMounted, computed } from 'vue'
import { SignatureUploadWidget } from '@grantstreet/uploads'

// See gsg-upload-input.d.ts for prop documentation

export default /*#__PURE__*/_defineComponent({
  __name: 'FormKitSignature',
  props: {
    context: {}
  },
  setup(__props: any) {

const props = __props;

/**
 * This is a FormKit wrapper for the SignatureUploadWidget widget, which
 * interfaces with the PSP Upload Service for uploading signatures in forms.
 */



const exceptionLogger = computed(() => {
  return props.context.node.config.rootConfig?.exceptionLogger
})

// Update the FormKit input value when the signature changes
function updateValue (newValue: string) {
  props.context.node.input(newValue)
}

/**
 * Prevents form submission if the signature upload widget is currently in the
 * process of uploading a signature.
 */
function handleIsUploading (isUploading: boolean) {
  if (isUploading) {
    props.context.node.store.set(createMessage({
      key: 'uploading',
      type: 'validation',
      blocking: true,
      visible: true,
      // XXX: We will need to translate this at some point.
      value: 'We are working on saving your signature(s). Please wait.',
    }))
  }
  else {
    props.context.node.store.remove('uploading')
  }
}

/**
 * Prevents form submission and prompts the user to refresh.
 */
function handleIsBlocked (isBlocked: boolean) {
  if (isBlocked) {
    props.context.node.store.set(createMessage({
      key: 'blocked',
      type: 'validation',
      blocking: true,
      visible: true,
      // XXX: We will need to translate this at some point.
      value: 'The form encountered an error. Please refresh.',
    }))
  }
}

onMounted(() => {
  if (!exceptionLogger.value) {
    throw new Error('No exceptionLogger registered in the FormKit config. See @grantstreet/formkit README for gsgInputsPlugin usage.')
  }

  props.context.node.input('')
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(SignatureUploadWidget), {
    id: props.context.id,
    name: props.context.node.name,
    "source-tag": props.context.sourceTag,
    "retain-until": props.context.retainUntil,
    disabled: Boolean(props.context.disabled),
    "max-file-size": props.context.maxFileSize,
    "exception-logger": exceptionLogger.value,
    "onUpdate:modelValue": updateValue,
    "onUpdate:isProcessing": handleIsUploading,
    "onUpdate:isBlocked": handleIsBlocked
  }, null, 8, ["id", "name", "source-tag", "retain-until", "disabled", "max-file-size", "exception-logger"]))
}
}

})